import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

gsap.set('.animation-scale-down', { scale: 1.2 })

gsap.utils.toArray('.animation-scale-down-container').forEach(element => {

  ScrollTrigger.create({
    trigger: element,
    start: 'top center',
    end: 'center center',
    scrub: true,
    once: true,
    //markers: true,
    onEnter: () => {
      let image = $(element).find('.animation-scale-down')

      gsap.to(image, { scale: 1 })
    }
  })

})
